import { FormControl, FormLabel } from "@mui/material";

function Fieldset({ children, label }) {
  return (
    <FormControl
      sx={{
        padding: "0 15px",
        marginBottom: "12px",
        borderRadius: ".375rem",
        border: "2px solid #d6d9f6",
      }}
      component="fieldset"
      fullWidth
    >
      <FormLabel
        sx={{ padding: "0 10px 8px 8px", color: "#1A73E7", fontWeight: "bold" }}
        component="legend"
      >
        {label}
      </FormLabel>
      {children}
    </FormControl>
  );
}

export default Fieldset;
